import { Navigate, Outlet, useLocation, useParams } from "react-router-dom";
import {
  SimpleSidebarContent,
  SimpleSidebarLayout,
} from "@volca/ui/components/ui/simple-sidebar";
import { useBusiness } from "@/core/business";
import { useGetMyUser } from "@/user/query";
import { BusinessSettingsSidebar } from "./common/business-settings-sidebar";
import { SettingsPageLoading } from "./common/settings-page-loading";
import { SETTINGS_PAGE_TITLES } from "./constants";
import { useBusinessSettingsSidebar } from "./context/business-settings-sidebar-context";
import { DeleteUserProvider } from "./users/context/delete-user-context";

const BusinessSettings = () => {
  const { businessId } = useParams();
  const { pathname } = useLocation();
  const { state, updateSidebar } = useBusinessSettingsSidebar();
  const { isLoading: isUserLoading } = useGetMyUser();
  const { businessId: userBusinessId, isLoading: isBusinessLoading } =
    useBusiness();

  const isLoading = isUserLoading || isBusinessLoading;

  if (isLoading || !businessId) {
    const page = pathname.split("/")[3] ?? "";
    return (
      <div className="mx-auto w-full max-w-7xl">
        <SettingsPageLoading title={SETTINGS_PAGE_TITLES[page] ?? "Settings"} />
      </div>
    );
  }

  if (!businessId || !userBusinessId) {
    return <Navigate to="/" />;
  }

  if (businessId !== userBusinessId) {
    return <Navigate to={`/business-settings/${userBusinessId}`} replace />;
  }

  return (
    <DeleteUserProvider>
      <SimpleSidebarLayout
        className="overflow-hidden"
        open={state.isOpen}
        onOpenChange={(open) => {
          updateSidebar({
            isOpen: open,
            selectedItemId: state.selectedItemId,
          });
        }}
      >
        {/* The page area's own kind of scroller, for the document pages (the
            business profile); workspace pages are exactly as tall as it. */}
        <SimpleSidebarContent removeScrollArea className="overflow-y-auto">
          {/* The settings column. Wide enough for a table, short of the app's
              1680px frame. */}
          <div className="mx-auto w-full max-w-7xl">
            <Outlet />
          </div>
        </SimpleSidebarContent>
        <BusinessSettingsSidebar businessId={businessId} />
      </SimpleSidebarLayout>
    </DeleteUserProvider>
  );
};

export default BusinessSettings;
